export function getScrollParent(node) {
  if (!node) return null;
  return node.scrollHeight > node.clientHeight ? node : getScrollParent(node.parentNode);
}
